<template>
  <UserLayout>
    <section class="md:px-12 xl:px-12 lg:px-16 lg:ml-20 px-4 mb-6">
      <div class="border-b border-gray-200 flex justify-between">
        <nav class="-mb-px flex space-x-8" aria-label="Tabs">
          <!-- Default: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" -->
          <router-link
            :to="{ name: '' }"
            class="border-green-dark text-gray-dark whitespace-nowrap hover:text-gray-dark hover:border-green-dark py-2 px-1 border-b-2 font-medium text-sm"
            :class="{ current: 'border-gray-dark text-gray-dark' }"
          >
            Beginner
          </router-link>

          <router-link
            :to="{ name: '' }"
            class="border-transparent text-gray-500 hover:text-gray-dark hover:border-green-dark whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
          >
            Intermediate
          </router-link>
          <router-link
            :to="{ name: '' }"
            class="border-transparent text-gray-500 hover:text-gray-dark hover:border-green-dark whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
            :class="{ current: 'border-gray-dark text-gray-dark' }"
          >
            Expert
          </router-link>
        </nav>
      </div>
    </section>
    <section class="flex flex-col gap-8 mb-20">
      <div class="px-12 ml-20">
        <div class="flex justify-between">
          <h6
            class="text-lg font-semibold leading-normal mt-0 mb-4 text-gray-dark"
          >
            Trending Videos
          </h6>
          <router-link
            :to="{ name: 'VodClasses' }"
          >
            <button
              class="h-8 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light ring-1 ring-green-light rounded-lg focus:outline-none hover:bg-white hover:text-green-light"
            >
              See All
            </button>
          </router-link>
        </div>
        <VodLibrary :data="completedSessions" />
      </div>

      <div class="px-12 ml-20">
        <div class="flex justify-between">
          <h6
            class="text-lg font-semibold leading-normal mt-0 mb-4 text-gray-dark"
          >
            Watch It Again
          </h6>
          <router-link
            :to="{ name: 'VodClasses' }"
          >
            <button
              class="h-8 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light ring-1 ring-green-light rounded-lg focus:outline-none hover:bg-white hover:text-green-light"
            >
              See All
            </button>
          </router-link>
        </div>
        <VodLibrary :data="completedSessions" />
      </div>
    </section>
  </UserLayout>
</template>

<script>
import UserLayout from "../../../components/layouts/UserLayout.vue";
import VodLibrary from "@/components/VodLibrary.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: { UserLayout, VodLibrary },
  data() {
    return {
      completedSessions: [],
    };
  },
  computed: {
    ...mapGetters(["userProfile"]),
  },
  created() {
    this.getVodList();
  },
  methods: {
    ...mapActions(["getUserProfile"]),
    async getVodList() {
      let query = {
        page: 1,
      };
      await this.getUserProfile({ query });
      this.completedSessions = this.userProfile.completed_sessions.data;
    },
  },
};
</script>

<style></style>
